export default {"src":"/_next/static/media/icone-profile.583e63da.svg","height":34,"width":28,"blurWidth":0,"blurHeight":0};